import React, { Component } from 'react';
import EditableScenario from "./EditableScenario";
import {formatDuration} from "../Utils/Utils";
import {Link} from "react-router-dom";
import LoadingSpinner from "../Utils/LoadingSpinner";

class Device extends Component {
    state = {
        loading: true, // will be true when ajax request is running
    };

    componentDidMount() {
        this.props.simGps.getDevice(this.props.uuid, (success, result) => {
            if ( success ) {
                const device = result.device;
                this.setState (
                    {
                        ...device,
                        loading: false,
                    }
                );
            } else {
                this.setState(
                    {
                        loading: false,
                    }
                );
            }
        } );
    }

    render() {
        const addMoneyPath = "/addmoney/" + this.props.uuid;

        if ( this.state.loading) {
            return <LoadingSpinner text="Loading device information ..." />
        }
        else {
            return (
                <div>
                    <p>Device ID: {this.props.uuid}</p>
                    <p>Time used: {formatDuration(this.state.billing.sec_used)}</p>
                    <p>Time granted: {formatDuration(this.state.billing.sec_granted)}</p>
                    <Link to={addMoneyPath}>Add money to this device</Link>
                    <p>
                        <EditableScenario
                            {...this.props}
                            {...this.state.billing}
                            {...this.state.scenario}
                        />
                    </p>
                </div>
            )
        }
    }
}


export default Device;
